define('ANSI/Components/Coveo/FilteredViewCategoryList',['jquery', 'eventManager', 'slick', 'underscore'], function (
    $,
    eventManager,
    slick,
    _
) {
    function FilteredViewCategoryList(
        scope,
        templates,
        selectedCategories,
        topics,
        doNotPrefilter,
        isEventsListing
    ) {
        var intervalCount = 0;
        var intervalId = setInterval(function () {
            intervalCount++;
            var testElement = Coveo.$$(document).find('.CoveoSearchInterface').CoveoQueryController;
            if ((testElement !== null && testElement !== undefined) || intervalCount > 25) {
                console.log('coveo cleared ' + intervalCount);
                clearInterval(intervalId);
            }
            var CoveoRelatedContent = function (element, root, options) {
                this.root = root;
                this.options = options;
                this.resultTemplate = _.template(this.options.resultTemplate);
                this.content = element;
                this.templateFilter = templates;
                this.selectedCategories = selectedCategories;
                this.topics = topics;
                this.doNotPrefilter = doNotPrefilter;
                this.isEventsListing = isEventsListing;
                this.fetchNewResults();
                //}, 0);
            };

            CoveoRelatedContent.prototype.fetchNewResults = function () {
                var _this = this;

                //Setting for the slick slider
                var settings = {
                    draggable: true,
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    accessibility: true,
                    centerMode: true,
                    arrows: true,
                    variableWidth: true,
                    touchThreshold: 10,
                    mobileFirst: true,
                    responsive: [{
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 2,
                            arrows: true,
                            centerMode: false
                        }
                    },
                    {
                        breakpoint: 1260,
                        settings: {
                            slidesToShow: 3,
                            arrows: true,
                            centerMode: false
                        }
                    },
                    {
                        breakpoint: 1439,
                        settings: {
                            slidesToShow: 4,
                            arrows: true,
                            centerMode: false
                        }
                    }
                    ]
                };

                var tabSettings = {
                    draggable: true,
                    infinite: false,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    accessibility: true,
                    centerMode: true,
                    arrows: true,
                    variableWidth: true,
                    touchThreshold: 10,
                    mobileFirst: true,
                    responsive: [{
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 2,
                            arrows: true,
                            centerMode: false
                        }
                    },
                    {
                        breakpoint: 1260,
                        settings: {
                            slidesToShow: 2,
                            arrows: true,
                            centerMode: false
                        }
                    },
                    {
                        breakpoint: 1439,
                        settings: {
                            slidesToShow: 3,
                            arrows: true,
                            centerMode: false
                        }
                    }
                    ]
                };


                var settingsCenter = {
                    draggable: true,
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    accessibility: true,
                    centerMode: true,
                    arrows: true,
                    variableWidth: false,
                    touchThreshold: 10,
                    mobileFirst: true,
                    responsive: [{
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 2,
                            arrows: true,
                            centerMode: false
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                            arrows: true,
                            centerMode: false
                        }
                    }
                    ]
                };

                //Initialize slider
                var sliderInit = function (results) {
                    var relatedContainer = $(_this.content).closest(
                        '.news-events-slider'
                    );
                    if (results.length > 0) {
                        var el = $(_this.content);
                        //See if slider is already initialized
                        if (!el.hasClass('slick-initialized')) {
                            if (el.closest('.score-stripe').hasClass('center')) {
                                el.slick(settingsCenter);
                            } else if (el.closest('.full-width').hasClass('tab')) {
                                el.slick(tabSettings);
                            } else {
                                el.slick(settings);
                            }
                        }
                    }
                };

                var tabsetRefresh = function (results) {
                    if (results.length == 0) {
                        var tabContainer = $(_this.content).closest(
                            '.news-events-slider'
                        );
                        var tabset = $(_this.content).closest('.score-tab');
                        var tab = $(_this.content).closest('.tab-pane').attr('id');
                        var li = tabset.find('li a[href="#' + tab + '"]').parent();
                        li.hide();
                        li.addClass('empty');
                        var visiblelistItems = li.parent().find('li').not('.empty').not('.active.empty');
                        if (visiblelistItems.length > 0) {
                            $(visiblelistItems[0]).find('a').tab('show');
                        } else {
                            tabContainer.hide();
                        }
                    }
                };

                var normalizeGuid = function (guid) {
                    return guid
                        .replace(/\|/g, ',')
                        .replace(/{/g, '')
                        .replace(/}/g, '')
                        .replace(/-/g, '');
                };

                var builder = Coveo.$$(document)
                    .find('.CoveoSearchInterface')
                    .CoveoQueryController.createQueryBuilder(
                        '.CoveoSearchInterface'
                    );

                builder.advancedExpression.add(
                    '@z95xtemplate==(' + normalizeGuid(_this.templateFilter) + ')'
                );
                var indexSource = Coveo.$$(document).find('.CoveoForSitecoreContext').CoveoForSitecoreContext.options.scIndexSourceName;

                if (
                    !_this.doNotPrefilter
                ) {
                    if (_this.selectedCategories) {
                        var formattedCategories = normalizeGuid(
                            _this.selectedCategories
                        );
                        builder.advancedExpression.add(
                            '@filteredz32xviewz32xcategory==(' +
                            formattedCategories +
                            ')'
                        );
                    }
                }

                if (!_this.doNotPrefilter) {
                    if (_this.selectedCategories) {
                        var formattedCategories = normalizeGuid(
                            _this.selectedCategories
                        );
                        builder.advancedExpression.add(
                            '@filteredz32xviewz32xcategory==(' +
                            formattedCategories +
                            ')'
                        );
                    }
                }

                if (_this.isEventsListing) {
                    builder.advancedExpression.add('@datesortdateformatcomputed >= today');
                    builder.sortCriteria = '@datesortdateformatcomputed ascending';
                } else {
                    builder.sortCriteria = '@datesortdateformatcomputed descending';
                }

                builder.constantExpression.add(
                    '@source=="' +
                    indexSource +
                    '"'
                );

                builder.constantExpression.add(
                    '@z95xlanguage==' +
                    document.documentElement.lang +
                    ''
                );

                builder.constantExpression.add(
                    '@z95xlatestversion==1'
                );

                var originalQuery = builder.build();

                originalQuery.locale = document.documentElement.lang;

                Coveo.SearchEndpoint.endpoints.default
                    .search(originalQuery)
                    .done(function (data) {
                        _.each(data.results, function (result, index) {
                            _this.content.insertAdjacentHTML(
                                'beforeend',
                                _this.resultTemplate({ result: result })
                            );
                        });
                        //Initialize slick slider after cards are built
                        sliderInit(data.results);
                        tabsetRefresh(data.results);
                    });
            };


            var template = Coveo.$$(scope).find(
                'script.by-related-content-result-template'
            ).innerHTML;

            var relatedContentDiv = Coveo.$$(scope).find(
                '.related-content-placeholder'
            );
            var interfaceDiv = Coveo.$$(scope).find('.CoveoSearchInterface');
            var options = {
                resultTemplate: template
            };

            var results = new CoveoRelatedContent(
                relatedContentDiv,
                interfaceDiv,
                options
            );
        }, 250);
    }

    FilteredViewCategoryList.init = function init(args) {
        return args.IsEditorEditing === true ?
            null :
            new FilteredViewCategoryList(
                args.scope,
                args.templates,
                args.selectedCategories,
                args.topics,
                args.doNotPrefilter,
                args.isEventsListing
            );
    };

    return FilteredViewCategoryList;

});

